import { useEffect, useMemo, useState, useContext } from "react";
import rootAction from "../../../stateManagment/actions/rootAction";
import { useAppDispatch } from "../../../stateManagment/reduxStore";
import debounce from 'lodash.debounce';
import { Button, Input, InputGroup, InputGroupAddon } from "reactstrap";
import { blur } from "../../../utils/blur";
import { replaceLoclizationLabel } from "../../../helpers/CommonHelper";
import { useSelector } from "react-redux";
import { ToggleContext } from '../../../ToggleProvider';

export const QuantityManipulator = ({ productDetail, initialProductActivity, colorInventory, initialQuantity = null, initialLineItemId = null }) => {
    const LocalizationLabelsArray = [];
    const [quantityRange, setQuantityRange] = useState({ min: 1, max: 300 });
    const productActivity = useSelector(state => state.pdpReducer);
    const dispatch = useAppDispatch();
    const currentCart = useSelector((state) => state.cartReducer);
    const { allotmentData } = useSelector((state) => state.commonReducer);
    const { isToggled, } = useContext(ToggleContext);
    const [isInitialQuantitySet, setIsInitialQuantitySet] = useState(initialQuantity == null);

    useEffect(() => {
        var range = getQtyRange();
        setQuantityRange(range);
        if (isInitialQuantitySet) {
            dispatch(rootAction.pdpActions.setQuantity({ quantity: productActivity?.quantity, maxQuantity: range.max, minQuantity: range.min }));
        } else {
            dispatch(rootAction.pdpActions.setQuantity({ quantity: initialQuantity, maxQuantity: range.max, minQuantity: range.min }));
            setIsInitialQuantitySet(true);
        }
    }, [currentCart, colorInventory, productActivity.selectedSizeId]);

    const getQtyRange = () => {
        // get style
        const style = productDetail.id +
            (initialProductActivity.selectedColorId ? '-' + initialProductActivity.selectedColorId : '') +
            (initialProductActivity.selectedSizeId ? '-' + initialProductActivity.selectedSizeId : '');

        // find inventory
        const inv = colorInventory?.find(c =>
            c.colorId === (initialProductActivity.selectedColorId ? initialProductActivity.selectedColorId : '') &&
            c.sizeId === (initialProductActivity.selectedSizeId ? initialProductActivity.selectedSizeId : ''));

        // get max quantity from inventory, default to 300
        let maxQuantity = inv ? inv.ats : productDetail?.maxQuantity || 300;
        const minQuantity = productDetail?.minQuantity || 1;

        if (isToggled) {
            // if it is allotment, limit max to allotment assignment to the user
            var matchingKey = "";
            for (const key in allotmentData) {
                // find the matching key, ie "Scrub Top" in "Scrub Top,Jacket,Polos"
                if (allotmentData.hasOwnProperty(key) && key.toLowerCase().indexOf(productDetail?.itemClass.toLowerCase()) > -1) {
                    matchingKey = key;
                    break;
                }
            }

            // set max if allowed, else 0
            var allotmentMax = allotmentData[matchingKey]?.allowed ?? 0;
            if (!!allotmentMax && allotmentMax > 0)
                maxQuantity = allotmentMax;
        }

        // find any possible quantities already in the cart
        let sumOfMatchingSkus = currentCart?.products
            .filter(f => f.productId === style &&
                (!initialLineItemId || initialLineItemId !== f.lineItemId))
            .map(m => m.quantity)
            .reduce((acc, curr) => acc + curr, 0);
        maxQuantity -= sumOfMatchingSkus; // subtract them from the max quantity
        
        return { min: minQuantity, max: maxQuantity };
    };

    const handleDecreaseQty = () => {
        dispatch(rootAction.pdpActions.decreaseQuantity(quantityRange.min));
    }

    const handleIncreaseQty = () => {
        dispatch(rootAction.pdpActions.increaseQuantity(quantityRange.max));
    }

    const handleChangQty = (e) => {
        const quantity = parseInt(e.target.value) || "";
        let qtyRange = getQtyRange();
        dispatch(rootAction.pdpActions.setQuantity({ quantity, maxQuantity: qtyRange.max, minQuantity: qtyRange.min }));
    }
    const debouncedChangeHandler = useMemo(
        () => debounce(handleChangQty, 1000)
        , []);

    return (
        <>
            <InputGroup className="custom-quantity">
                <InputGroupAddon addonType="prepend">
                    <Button
                        className="quantity-decrease"
                        disabled={Number(productActivity?.quantity) === quantityRange.min}
                        onClick={(e) => blur(e, handleDecreaseQty)}>
                    </Button>
                </InputGroupAddon>
                <Input
                    min={quantityRange.min}
                    max={quantityRange.max}
                    maxLength={3}
                    value={productActivity?.quantity}
                    className="text-center"
                    onChange={(e) => {
                        dispatch(rootAction.pdpActions.setOptimisticQuantity(e.target.value));
                        debouncedChangeHandler(e);
                    }} />
                <InputGroupAddon addonType="append">
                    <Button
                        className="quantity-increase"
                        disabled={Number(productActivity?.quantity) === quantityRange.max}
                        onClick={(e) => blur(e, handleIncreaseQty)}>
                    </Button>
                </InputGroupAddon>
            </InputGroup>
            {productActivity?.quantityWarning && quantityRange.max > 0 && <div className='invalid-feedback'>
                {LocalizationLabelsArray ?
                    replaceLoclizationLabel(LocalizationLabelsArray, `The maximum available quantity is ${quantityRange.max}. Please update your quantity`, "lbl_prd_det_invalidquantity")
                    :
                    `The maximum available quantity is ${quantityRange.max}. Please update your quantity`
                }
            </div>}
        </>
    )
}